import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface CorporationPositionDeleteProps {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}
const CorporationPositionDelete = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: CorporationPositionDeleteProps) => {
  const { t } = useTranslation();
  return (
    <CustomSharedConfirmationModal
      open={open}
      title={`${t("delete")} ${t("position")}`}
      description={t("delete_resource_description", { name: t("position") })}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};
export default CorporationPositionDelete;
